import {
  MARKET_FILTER,
  type DashboardSection,
} from '@/features/dashboard/api/schemas'
import { useDashboardStructure } from '@/features/dashboard/api/queries'
import { sectionTakes } from '@/features/dashboard/model/sections'
import { visibleMarkets } from './filterState'

/** The markets that get a chip in a section; none if its cards ignore them. */
export const useSectionMarkets = (section: DashboardSection) => {
  const { data: dashboard } = useDashboardStructure()
  return sectionTakes(section, MARKET_FILTER)
    ? visibleMarkets(dashboard?.filters?.markets ?? [])
    : undefined
}
